import { render, staticRenderFns } from "./AvdComportamental.vue?vue&type=template&id=67d19508"
import script from "./AvdComportamental.vue?vue&type=script&lang=js"
export * from "./AvdComportamental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports